import { getIsAuthenticated } from '../../../../domain/hidden-data-provider';

const NoNotifications = () => {

    const isUserLoggedIn = getIsAuthenticated();

    return (
        <div className="text-center">
            {
                isUserLoggedIn &&
                <>
                    You have no notifications.
                </>
            }

            {
                !isUserLoggedIn &&
                <>
                    Please <a  href={ '/login?returnurl=' + encodeURIComponent(window.location.pathname )}>log in</a> to see your notifications.
                </>
            }
        </div>
    )
};

export default NoNotifications;